import * as types from '../mutation-types'

// initial state
const state = {
  langList: window.lang,
  requestAllow: true,
  currentTemplate: window._currentTemplate,
  customTemplate: window._customTemplate,
  tvIconFlag: window.tvIconFlag,
  gameBannerId: null
}

// getters
const getters = {
  langList: state => state.langList,
  requestAllow: state => state.requestAllow,
  customTemplate: state => state.customTemplate,
  currentTemplate: state => state.currentTemplate,
  tvIconFlag: state => state.tvIconFlag,
  gameBannerId: state => state.gameBannerId,

}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.REQUEST_ALLOW](state, payload) {
    state.requestAllow = payload
  },
  [types.GAME_BANNER_ID](state, payload) {
    state.gameBannerId = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/system.js